module.exports = __webpack_public_path__ + "static/media/autostraighten_original.cd163ae5.jpg";